const selectList = [
   [
      { title: "Chọn học kỳ" },
      { value: 0, title: "HK1 (2021-2022)" },
      { value: 1, title: "HK2 (2021-2022)" },
      { value: 2, title: "HK3 (2021-2022)" },
      { value: 3, title: "HK1 (2022-2023)" },
      { value: 4, title: "HK2 (2022-2023)" },
      { value: 5, title: "HK3 (2022-2023)" },
   ],
   [
      { title: "Chọn" },
      { value: 0, title: "Tất cả" },
      { value: 1, title: "Mới & chưa xem" },
      { value: 2, title: "Hết hạn" },
   ],
   [
      { title: "Chọn" },
      { value: 0, title: "Ấn Độ" },
      { value: 1, title: "Angola" },
      { value: 2, title: "Anh Quốc" },
      { value: 3, title: "Australia" },
      { value: 4, title: "Bắc Ai Len" },
      { value: 5, title: "Belarus" },
      { value: 6, title: "Bỉ" },
      { value: 7, title: "Bungari" },
      { value: 8, title: "Canada" },
      { value: 9, title: "Cộng Hoà CHDCND Lào" },
      { value: 10, title: "Cộng Hoà DC Đức" },
      { value: 11, title: "Cộng Hoà LB Đức" },
      { value: 12, title: "Cộng Hoà LB Nga" },
      { value: 13, title: "Cộng Hoà Pháp" },
      { value: 14, title: "Đài Loan" },
      { value: 15, title: "Hà Lan" },
      { value: 16, title: "Hàn Quốc" },
      { value: 17, title: "Hoa Kỳ" },
      { value: 18, title: "Hồng Kông" },
      { value: 19, title: "Hunggari" },
      { value: 20, title: "Indonesia" },
      { value: 21, title: "Liên Xô (cũ)" },
      { value: 22, title: "Mỹ" },
      { value: 23, title: "Nhật Bản" },
      { value: 24, title: "Philippines" },
      { value: 25, title: "Singapore" },
      { value: 26, title: "Slovakia" },
      { value: 27, title: "Thái Lan" },
      { value: 28, title: "Thụy Điển" },
      { value: 29, title: "Thụy Sỹ" },
      { value: 30, title: "Tiệp Khắc" },
      { value: 31, title: "Trung Quốc" },
      { value: 32, title: "Việt Nam" },
   ],
   [
      { title: "Chọn" },
      { value: 0, title: "Ba-Na" },
      { value: 1, title: "Bố Y" },
      { value: 2, title: "Brâu" },
      { value: 3, title: "Bru-Vân Kiều" },
      { value: 4, title: "Ca Dong" },
      { value: 5, title: "Chăm" },
      { value: 6, title: "Chơ-Ro" },
      { value: 7, title: "Chu-Ru" },
      { value: 8, title: "Chứt" },
      { value: 9, title: "Co" },
      { value: 10, title: "Cơ Lao" },
      { value: 11, title: "Cơ-Ho" },
      { value: 12, title: "Cống" },
      { value: 13, title: "Cơ-Tu" },
      { value: 14, title: "Dao" },
      { value: 15, title: "Ê-Đê" },
      { value: 16, title: "Gia-Rai" },
      { value: 17, title: "Giáy" },
      { value: 18, title: "Gié-Triêng" },
      { value: 19, title: "Hà Nhì" },
      { value: 20, title: "Hán" },
      { value: 21, title: "Hmông" },
      { value: 22, title: "Hoa" },
      { value: 23, title: "Hrê" },
      { value: 24, title: "Kháng" },
      { value: 25, title: "Khơ-Me" },
      { value: 26, title: "Khơ-Mú" },
      { value: 27, title: "Kinh" },
      { value: 28, title: "La Chi" },
      { value: 29, title: "La Ha" },
      { value: 30, title: "La Hủ" },
      { value: 31, title: "Lào" },
      { value: 32, title: "Lô Lô" },
      { value: 33, title: "Lự" },
      { value: 34, title: "Mạ" },
      { value: 35, title: "Mảng" },
      { value: 36, title: "Mèo" },
      { value: 37, title: "Mnông" },
      { value: 38, title: "Mường" },
      { value: 39, title: "Ngái" },
      { value: 40, title: "Nùng" },
      { value: 41, title: "Ơ Đu" },
      { value: 42, title: "Pà Thẻn" },
      { value: 43, title: "Phù Lá" },
      { value: 44, title: "Pu Péo" },
      { value: 45, title: "Ra-Glai" },
      { value: 46, title: "Rơ-Măm" },
      { value: 47, title: "Sán Chay" },
      { value: 48, title: "Sán Dìu" },
      { value: 49, title: "Si La" },
      { value: 50, title: "Tà Mun" },
      { value: 51, title: "Ta-Ôi" },
      { value: 52, title: "Tày" },
      { value: 53, title: "Thái" },
      { value: 54, title: "Thổ" },
      { value: 55, title: "Xinh-Mun" },
      { value: 56, title: "Xơ-Đăng" },
      { value: 57, title: "Xtiêng" },
      { value: 58, title: "Người Nước Ngoài" },
      { value: 59, title: "Khác" },
   ],
   [
      { title: "Chọn" },
      { value: 0, title: "Cao đài" },
      { value: 1, title: "Công giáo" },
      { value: 2, title: "Hoà Hảo" },
      { value: 3, title: "Hồi giáo" },
      { value: 4, title: "Phật giáo" },
      { value: 5, title: "Thiên chúa" },
      { value: 6, title: "Tin lành" },
      { value: 7, title: "Khác" },
      { value: 8, title: "Không" },
   ],
   [
      { title: "Chọn Tỉnh/ Thành phố" },
      { value: 0, title: "Bộ quốc phòng" },
      { value: 1, title: "Hà Bắc" },
      { value: 2, title: "Hà Nam Ninh" },
      { value: 3, title: "Hà Nội cũ" },
      { value: 4, title: "Hà Tây" },
      { value: 5, title: "Hà Tây cũ" },
      { value: 6, title: "Hải Hưng" },
      { value: 7, title: "Nam Hà" },
      { value: 8, title: "Sông Bé" },
      { value: 9, title: "Thành phố Cần Thơ" },
      { value: 10, title: "Thành phố Đà Nẵng" },
      { value: 11, title: "Thành phố Hà Nội" },
      { value: 12, title: "Thành phố Hải Phòng" },
      { value: 13, title: "Thành phố Hồ Chí Minh" },
      { value: 14, title: "Thuận Hải" },
      { value: 15, title: "Tỉnh An Giang" },
      { value: 16, title: "Tỉnh Bà Rịa - Vũng Tàu" },
      { value: 17, title: "Tỉnh Bắc Giang" },
      { value: 18, title: "Tỉnh Bắc Kạn" },
      { value: 19, title: "Tỉnh Bắc Liêu" },
      { value: 20, title: "Tỉnh Bắc Ninh" },
      { value: 21, title: "Tỉnh Bến Tre" },
      { value: 22, title: "Tỉnh Bình Định" },
      { value: 23, title: "Tỉnh Bình Dương" },
      { value: 24, title: "Tỉnh Bình Phước" },
      { value: 25, title: "Tỉnh Bình Thuận" },
      { value: 26, title: "Tỉnh Cà Mau" },
      { value: 27, title: "Tỉnh Cao Bằng" },
      { value: 28, title: "Tỉnh Đắk Lắk" },
      { value: 29, title: "Tỉnh Đắk Nông" },
      { value: 30, title: "Tỉnh Điện Biên" },
      { value: 31, title: "Tỉnh Đồng Nai" },
      { value: 32, title: "Tỉnh Đồng Tháp" },
      { value: 33, title: "Tỉnh Gia Lai" },
      { value: 34, title: "Tỉnh Hà Giang" },
      { value: 35, title: "Tỉnh Hà Nam" },
      { value: 36, title: "Tỉnh Hà Tinh" },
      { value: 37, title: "Tỉnh Hải Dương" },
      { value: 38, title: "Tỉnh Hải Hưng" },
      { value: 39, title: "Tỉnh Hậu Giang" },
      { value: 40, title: "Tỉnh Hòa Bình" },
      { value: 41, title: "Tỉnh Hưng Yên" },
      { value: 42, title: "Tỉnh Khánh Hòa" },
      { value: 43, title: "Tỉnh Kiên Giang" },
      { value: 44, title: "Tỉnh Kon Tum" },
      { value: 45, title: "Tỉnh Lai Châu" },
      { value: 46, title: "Tỉnh Lâm Đồng" },
      { value: 47, title: "Tỉnh Lạng Son" },
      { value: 48, title: "Tỉnh Lào Cai" },
      { value: 49, title: "Tỉnh Long An" },
      { value: 50, title: "Tỉnh Nam Định" },
      { value: 51, title: "Tỉnh Nghệ An" },
      { value: 52, title: "Tỉnh Ninh Bình" },
      { value: 53, title: "Tỉnh Ninh Thuận" },
      { value: 54, title: "Tỉnh Phú Thọ" },
      { value: 55, title: "Tỉnh Phú Yên" },
      { value: 56, title: "Tỉnh Quảng Bình" },
      { value: 57, title: "Tỉnh Quảng Nam" },
      { value: 58, title: "Tỉnh Quảng Ngãi" },
      { value: 59, title: "Tỉnh Quảng Ninh" },
      { value: 60, title: "Tỉnh Quảng Trị" },
      { value: 61, title: "Tỉnh Sóc Trăng" },
      { value: 62, title: "Tỉnh Sơn La" },
      { value: 63, title: "Tỉnh Tây Ninh" },
      { value: 64, title: "Tỉnh Thái Bình" },
      { value: 65, title: "Tỉnh Thái Nguyên" },
      { value: 66, title: "Tỉnh Thanh Hóa" },
      { value: 67, title: "Tỉnh Thừa Thiên Huế" },
      { value: 68, title: "Tỉnh Tiền Giang" },
      { value: 69, title: "Tỉnh Trà Vinh" },
      { value: 70, title: "Tỉnh Tuyên Quang" },
      { value: 71, title: "Tỉnh Vĩnh Long" },
      { value: 72, title: "Tỉnh Vĩnh Phúc" },
      { value: 73, title: "Tỉnh Yên Bái" },
      { value: 74, title: "Thái Lan" },
      { value: 75, title: "Hồng Kông" },
      { value: 76, title: "Liên bang Nga" },
      { value: 77, title: "Malaysia" },
   ],
   [
      { title: "Chọn" },
      { value: 0, title: "Anh trai" },
      { value: 1, title: "Chị gái" },
      { value: 2, title: "Chồng" },
      { value: 3, title: "Con ruột" },
      { value: 4, title: "Em gái" },
      { value: 5, title: "Em trai" },
      { value: 6, title: "Vợ" },
      { value: 7, title: "Khác" },
   ],
   [
      { value: 0, title: "Tất cả" },
      { value: 1, title: "HK1 (2021-2022)" },
      { value: 2, title: "HK2 (2021-2022)" },
      { value: 3, title: "HK3 (2021-2022)" },
      { value: 4, title: "HK1 (2022-2023)" },
      { value: 5, title: "HK2 (2022-2023)" },
      { value: 6, title: "HK3 (2022-2023)" },
   ],
];

const Select = (props) => {
   const options = selectList.map((row, index) => {
      if (index === props.index) {
         return row.map((option, index1) => {
            return (
               <option key={index1} value={option.value}>
                  {option.title}
               </option>
            );
         });
      }
      return true;
   });

   const handleChange = (e) => {
      const mode = e.target.value;
      if (props.setSelectedModeTable) props.setSelectedModeTable(mode);
      else if (props.setSelectedModeCol) props.setSelectedModeCol(mode);
      else if (props.setSelectValueDebt) props.setSelectValueDebt(mode);
      else if (props.setSelectValueProgress) props.setSelectValueProgress(mode);
      else if (props.setSelectValueRegisterCourse)
         props.setSelectValueRegisterCourse(mode);
   };

   return (
      <>
         <select onChange={handleChange} defaultValue={props.defaultValue || 0}>
            {options}
         </select>
      </>
   );
};

export default Select;
